/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { Integration, List, SpaceIntegrationBlocks } from "./data-contracts";

/**
 * No description
 * @tags space-integrations
 * @name ListSpaceIntegrations
 * @summary List integrations enabled in a space
 * @request GET:/spaces/{spaceId}/integrations
 * @secure
 */

// @ts-ignore
export const listSpaceIntegrations: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** A search string to filter integrations by name */
    search?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Integration[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/integrations",
  method: "get",
  streaming: false,
  tags: ["space-integrations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-integrations
 * @name ListSpaceIntegrationsBlocks
 * @summary List all space integrations blocks
 * @request GET:/spaces/{spaceId}/integration-blocks
 * @secure
 */

// @ts-ignore
export const listSpaceIntegrationsBlocks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SpaceIntegrationBlocks;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/integration-blocks",
  method: "get",
  streaming: false,
  tags: ["space-integrations"],
  criticalityLevel: "low",
  deprecated: false,
};
